import React from "react";
import { RoutingFormsProvider } from "./context/RoutingFormsContext";

// This is a wrapper component to provide the routing forms context
const RoutingFormsContextWrapper = ({ children, spaceId }) => {
  return (
    <RoutingFormsProvider spaceId={spaceId}>{children}</RoutingFormsProvider>
  );
};

export default RoutingFormsContextWrapper;
